import 'foundation-sites/js/entries/foundation'
import 'foundation-sites/js/entries/foundation-plugins'

jQuery(document).ready($ => ($(document).foundation()));



// WEBPACK FOOTER //
// ./scripts/autoload/_foundation.js